import React from 'react';

export function Card({ children, title, className = '' }) {
    return (
        <div
            className={`rounded-lg shadow-md border bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 ${className}`}
        >
            {title && (
                <div
                    className="p-4 border-b border-gray-200 dark:border-gray-700"
                >
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white m-0">
                        {title}
                    </h3>
                </div>
            )}
            <div className="p-4">
                {children}
            </div>
        </div>
    );
}
